import React from "react";
import { isMobile } from "react-device-detect";
import { Trans } from "react-i18next";

import { ACTCODE_TITLE } from "constant/log";
import { TITLE } from "constant/search";
import { JAVASCRIPT_VOID, STBBS_DOMAIN } from "constant/config";

import PrintDate from "components/boards/common/PrintDate";
import Highlight from "components/Highlight";
import Nickname from "components/contents/Nickname";
import PlaylistLink from "components/boards/playlist/PlaylistLink";
import { ButtonLink } from "components/ButtonLink";

const PlaylistInfo = ({ playlistUser, inflowPath }) => {
	const { playlist = {} } = playlistUser;
	const { config = {} } = playlist;

	return (
		<div className="vod-info">
			{isMobile && (
				<>
					{/* 제목 영역 */}
					<p className="title">{playlist.title}</p>

					{/* 정보 영역 */}
					<div className="info">
						{/* 재생목록 원자작자 닉네임 노출 */}
						{playlistUser.is_origin !== 1 && <span className="nick">{playlist.reg_nick || playlist.reg_id}</span>}

						{/* 재생목록 업데이트 날짜 */}
						<span className="update">
							<Trans>업데이트</Trans> {` `}
							<PrintDate target={playlist.update_date} />
						</span>

						{/* 비공개 재생목록 아이콘 노출 */}
						{config.display === "N" && (
							<span className="ico_hidden">
								<Trans>비공개</Trans>
							</span>
						)}
					</div>
				</>
			)}

			{!isMobile && (
				<>
					{/* 제목 영역 */}
					<p className="title">
						<PlaylistLink playlist={playlist} inflowPaths={inflowPath}>
							<Highlight type={TITLE} __html={playlist.title} />
						</PlaylistLink>
					</p>

					{/* 영상 정보 영역 */}
					<div className="info">
						{/* 영상 등록한 닉네임 노출*/}
						{playlistUser.is_origin !== 1 && (
							<Nickname item={{ user_id: playlist.reg_id }} right="auto">
								<a href={JAVASCRIPT_VOID} className="nick">
									{playlist.reg_nick || playlist.reg_id}
								</a>
							</Nickname>
						)}

						{/* 재생목록 업데이트 날짜 */}
						<em className="update">

							<Trans>업데이트</Trans> {` `}
							<PrintDate target={playlist.update_date} />

						</em>

						<div className="allList">
							{/* 재생목록 리스트 페이지 이동 */}
							<ButtonLink to={`${STBBS_DOMAIN}/vodplaylist/index.php?nPlaylistIdx=${playlist.idx}`} target="_blank">
								<Trans>전체보기</Trans>
							</ButtonLink>

							{/* 비공개 아이콘 노출 */}
							{config.display === "N" && <span className="hidden_list"><Trans>비공개</Trans></span>}
						</div>
					</div>
				</>
			)}
		</div>
	);
};

export default PlaylistInfo;
